import { SHOW_HIDE_LOADER } from "../actions/types";

export default (iShow = false, action) => {
  if (action.type === SHOW_HIDE_LOADER) {
    return action.payload;
  }
  return iShow;
};
